import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const tenderKeys = [
  ['cash', 'appliedPriceCash'], ['card', 'appliedPriceCard'],
  ['bank', 'appliedPriceBank'], ['mobile', 'appliedPriceMobile'],
];

/** Editable preflight: the final accept request receives these exact tender prices. */
const AppliedPricingDialog = ({ open, pricing, onClose, onConfirm, loading = false }) => {
  const { t } = useTranslation();
  const [values, setValues] = React.useState(pricing);
  React.useEffect(() => setValues(pricing), [pricing]);
  if (!pricing) return null;
  const editable = Boolean(onConfirm);
  const hasValidPrices = tenderKeys.every(([field]) => Number.isFinite(Number(values?.[field])) && Number(values[field]) > 0);
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ pb: 0, fontWeight: 700 }}>{t('appliedPrices')}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 2 }}>
          {editable ? t('appliedPricesReview') : t('appliedPricesConfirmed')}
        </Typography>
        {pricing.productName && (
          <Typography sx={{ fontWeight: 700, fontSize: '13px', mb: 1.5 }}>
            {pricing.productName}
          </Typography>
        )}
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1 }}>
          {tenderKeys.map(([field, label]) => (
            <Box key={field} sx={{ p: 1.25, borderRadius: 1.5, bgcolor: 'rgba(40,25,62,0.05)' }}>
              <Typography variant="caption" color="text.secondary">{t(label)}</Typography>
              {editable ? <TextField size="small" type="number" inputProps={{ min: 0.01, step: 0.01 }} value={values?.[field] ?? ''} onChange={(e) => setValues((current) => ({ ...current, [field]: Number(e.target.value) }))} sx={{ mt: .5, width: '100%' }} /> : <Typography sx={{ fontWeight: 700 }}>€{Number(pricing[field] || 0).toFixed(2)}</Typography>}
            </Box>
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>{editable ? t('cancel') : t('close')}</Button>
        {editable && <Button variant="contained" onClick={() => onConfirm(values)} disabled={loading || !hasValidPrices}>{t('accept')}</Button>}
      </DialogActions>
    </Dialog>
  );
};

export default AppliedPricingDialog;
